<ion-list>

    <!-- Add owner -->
    <!-- <ion-item button (click)="dismiss('owner')">
        <ion-label>{{ 'Add team admin' | translate }}</ion-label>
        <ion-icon slot="start" color="secondary" name="person-add"></ion-icon>
    </ion-item> -->

    <!-- Delete team -->
    <ion-item button *ngIf="isOwner" (click)="dismiss('update')">
        <ion-label> {{ 'Update team' | translate }}</ion-label>
        <ion-icon slot="start" color="secondary" name="build"></ion-icon>
    </ion-item>

    <!-- Delete team -->
    <ion-item button *ngIf="isOwner" (click)="dismiss('delete')">
        <ion-label> {{ 'Delete team' | translate }}</ion-label>
        <ion-icon slot="start" color="danger" name="trash"></ion-icon>
    </ion-item>

    <ion-item button *ngIf="canFollow" (click)="dismiss('leave')">
        <ion-label> {{ 'Leave Team' | translate }}</ion-label>
        <ion-icon slot="start" color="secondary" name="exit-outline"></ion-icon>
    </ion-item>

</ion-list>